import { render, staticRenderFns } from "./HSInspectManageMaterialDetail.vue?vue&type=template&id=1a1fb3e1&scoped=true"
import script from "./HSInspectManageMaterialDetail.vue?vue&type=script&lang=js"
export * from "./HSInspectManageMaterialDetail.vue?vue&type=script&lang=js"
import style0 from "./HSInspectManageMaterialDetail.vue?vue&type=style&index=0&id=1a1fb3e1&prod&lang=less&scoped=true"
import style1 from "./HSInspectManageMaterialDetail.vue?vue&type=style&index=1&id=1a1fb3e1&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a1fb3e1",
  null
  
)

export default component.exports